module.exports = __webpack_public_path__ + "img/item10.4d10821c.png";